/**
 * @generated SignedSource<<4b264c34f4b64949efc22124ee7d6b26>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MSTeamsConfigurationInput = {
  accessConfig?: MSTeamsAccessConfigInput | null | undefined;
  accessConfigBlob?: string | null | undefined;
  channelMappings?: ReadonlyArray<MSTeamsChannelMappingInput> | null | undefined;
  customerConfig?: MSTeamsCustomerConfigInput | null | undefined;
  name: string;
  scope: string;
};
export type MSTeamsCustomerConfigInput = {
  prefix?: string | null | undefined;
  tags?: ReadonlyArray<TagInput> | null | undefined;
};
export type TagInput = {
  key: string;
  value?: string | null | undefined;
};
export type MSTeamsAccessConfigInput = {
  clientId: string;
  roundtripDigest: string;
  tenantId: string;
};
export type MSTeamsChannelMappingInput = {
  channelId: string;
  name: string;
  teamId: any;
};
export type UpsertMSTeamsProfileMutation$variables = {
  connections: ReadonlyArray<string>;
  input: MSTeamsConfigurationInput;
};
export type UpsertMSTeamsProfileMutation$data = {
  readonly upsertMSTeamsProfile: {
    readonly configuration: {
      readonly profile: string;
      readonly record: {
        readonly accessConfig?: {
          readonly botApplication: {
            readonly downloadURL: string;
            readonly version: string;
          };
          readonly clientId: string;
          readonly publishedApplication: {
            readonly application: {
              readonly catalogId: string | null | undefined;
              readonly checkedAt: string;
              readonly version: string | null | undefined;
            } | null | undefined;
            readonly problems: ReadonlyArray<{
              readonly message: string;
            }>;
          } | null | undefined;
          readonly roundtripDigest: string;
          readonly tenantId: string;
        } | null | undefined;
        readonly channelMappings?: ReadonlyArray<{
          readonly channelId: string;
          readonly name: string;
          readonly teamId: any;
        }> | null | undefined;
        readonly customerConfig?: {
          readonly prefix: string;
          readonly roundtripDigest: string;
          readonly tags: ReadonlyArray<{
            readonly key: string;
            readonly value: string | null | undefined;
          }>;
          readonly terraformModule: {
            readonly source: string;
            readonly version: string;
          };
        };
        readonly entityDetails?: {
          readonly channels: ReadonlyArray<{
            readonly id: string;
            readonly name: string;
          }>;
          readonly teams: ReadonlyArray<{
            readonly id: any;
            readonly name: string;
          }>;
        };
      };
      readonly scope: string;
    };
  } | null | undefined;
};
export type UpsertMSTeamsProfileMutation = {
  response: UpsertMSTeamsProfileMutation$data;
  variables: UpsertMSTeamsProfileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profile",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "MSTeamsBotApplication",
  "kind": "LinkedField",
  "name": "botApplication",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downloadURL",
      "storageKey": null
    },
    (v4/*:: as any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "MSTeamsPublishedApplication",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "catalogId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkedAt",
      "storageKey": null
    },
    (v4/*:: as any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roundtripDigest",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tenantId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "MSTeamsChannelMapping",
  "kind": "LinkedField",
  "name": "channelMappings",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "channelId",
      "storageKey": null
    },
    (v11/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "MSTeamsCustomerConfig",
  "kind": "LinkedField",
  "name": "customerConfig",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prefix",
      "storageKey": null
    },
    (v9/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Tag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TerraformModule",
      "kind": "LinkedField",
      "name": "terraformModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "source",
          "storageKey": null
        },
        (v4/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v15 = [
  (v14/*:: as any*/),
  (v11/*:: as any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "MSTeamsEntityDetails",
  "kind": "LinkedField",
  "name": "entityDetails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MSTeamsChannelDetails",
      "kind": "LinkedField",
      "name": "channels",
      "plural": true,
      "selections": (v15/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MSTeamsTeamDetails",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": (v15/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scope",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpsertMSTeamsProfileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "ConfigurationPayload",
        "kind": "LinkedField",
        "name": "upsertMSTeamsProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Configuration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "record",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MSTeamsAccessConfig",
                        "kind": "LinkedField",
                        "name": "accessConfig",
                        "plural": false,
                        "selections": [
                          (v5/*:: as any*/),
                          (v6/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MSTeamsPublishedApplicationPayload",
                            "kind": "LinkedField",
                            "name": "publishedApplication",
                            "plural": false,
                            "selections": [
                              (v7/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "problems",
                                "plural": true,
                                "selections": [
                                  (v8/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v9/*:: as any*/),
                          (v10/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v12/*:: as any*/),
                      (v13/*:: as any*/),
                      (v16/*:: as any*/)
                    ],
                    "type": "MSTeamsConfiguration",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v17/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "UpsertMSTeamsProfileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "ConfigurationPayload",
        "kind": "LinkedField",
        "name": "upsertMSTeamsProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Configuration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "record",
                "plural": false,
                "selections": [
                  (v18/*:: as any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MSTeamsAccessConfig",
                        "kind": "LinkedField",
                        "name": "accessConfig",
                        "plural": false,
                        "selections": [
                          (v5/*:: as any*/),
                          (v6/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MSTeamsPublishedApplicationPayload",
                            "kind": "LinkedField",
                            "name": "publishedApplication",
                            "plural": false,
                            "selections": [
                              (v7/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "problems",
                                "plural": true,
                                "selections": [
                                  (v18/*:: as any*/),
                                  (v8/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v9/*:: as any*/),
                          (v10/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v12/*:: as any*/),
                      (v13/*:: as any*/),
                      (v16/*:: as any*/)
                    ],
                    "type": "MSTeamsConfiguration",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v17/*:: as any*/),
              (v14/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "configuration",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "ConfigurationEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e9e40623a02ab1693736a8df393a9d21",
    "id": null,
    "metadata": {},
    "name": "UpsertMSTeamsProfileMutation",
    "operationKind": "mutation",
    "text": "mutation UpsertMSTeamsProfileMutation(\n  $input: MSTeamsConfigurationInput!\n) {\n  upsertMSTeamsProfile(input: $input) {\n    configuration {\n      profile\n      record {\n        __typename\n        ... on MSTeamsConfiguration {\n          accessConfig {\n            botApplication {\n              downloadURL\n              version\n            }\n            clientId\n            publishedApplication {\n              application {\n                catalogId\n                checkedAt\n                version\n              }\n              problems {\n                __typename\n                message\n              }\n            }\n            roundtripDigest\n            tenantId\n          }\n          channelMappings {\n            channelId\n            name\n            teamId\n          }\n          customerConfig {\n            prefix\n            roundtripDigest\n            tags {\n              key\n              value\n            }\n            terraformModule {\n              source\n              version\n            }\n          }\n          entityDetails {\n            channels {\n              id\n              name\n            }\n            teams {\n              id\n              name\n            }\n          }\n        }\n      }\n      scope\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9276444414f60b80cfa2c7ab5ffdad06";

export default node;
